import { create } from 'zustand';
import { IActiveItem } from '../models/modules';
import { persist } from 'zustand/middleware';

interface DisciplineState {
  activeDiscipline: IActiveItem | null;
  activeModule: IActiveItem | null;
  activeSubject: IActiveItem | null;
  activeContent: IActiveItem | null;
  _hasHydrated: boolean | null;
  setActiveDiscipline: (item: IActiveItem | null) => void;
  setActiveModule: (item: IActiveItem | null) => void;
  setActiveSubject: (item: IActiveItem | null) => void;
  setActiveContent: (item: IActiveItem | null) => void;
  setHasHydrated: (hydrate: boolean) => void;
  resetDiscipline: () => void;
}

export const useDisciplineStore = create<DisciplineState>()(
  persist(
    (set) => ({
      activeDiscipline: null,
      activeModule: null,
      activeSubject: null,
      activeContent: null,
      _hasHydrated: false,
      setActiveDiscipline: (item: IActiveItem | null) =>
        set({ activeDiscipline: item }),
      setActiveModule: (item: IActiveItem | null) =>
        set({ activeModule: item }),
      setActiveSubject: (item: IActiveItem | null) =>
        set({ activeSubject: item }),
      setActiveContent: (item: IActiveItem | null) =>
        set({ activeContent: item }),
      setHasHydrated: (hydrate: boolean) => set({ _hasHydrated: hydrate }),
      resetDiscipline: () =>
        set({
          activeDiscipline: null,
          activeModule: null,
          activeSubject: null,
          activeContent: null,
          _hasHydrated: false,
        }),
    }),
    {
      name: 'discipline-store',
      onRehydrateStorage: () => (state) => {
        state && state.setHasHydrated(true);
      },
    }
  )
);
